export default __webpack_public_path__ + "static/altostruct-968ddbe41d8705923d587b0305079b75.png";